import React, { useContext } from 'react';
import { Modal, Button, Header, Label, Icon } from 'semantic-ui-react';

import { StoreContext } from '../../store/StoreProvider';
import Act from '../../store/actions';

// config for label text
const labelTextConfig = {
	default: {
		headerSize: 'h4',
	},
	publication: {
		headerSize: 'h4',
		iconName: 'book',
		labelText: 'Publication',
		order: 1,
		color: 'blue',
	},
	publicationfa: {
		headerSize: 'h5',
		iconName: 'book',
		labelText: 'Publication(fa)',
		order: 2,
		color: 'blue',
		dir: 'rtl',
	},
	author: {
		headerSize: 'h4',
		iconName: 'user outline',
		labelText: 'Author',
		order: 3,
		color: 'teal',
	},
	authorfa: {
		headerSize: 'h5',
		iconName: 'user outline',
		labelText: 'Author(fa)',
		order: 4,
		color: 'teal',
		dir: 'rtl',
	},
	location: {
		headerSize: 'h5',
		iconName: 'map marker alternate',
		labelText: 'Location',
		order: 5,
		color: 'orange',
	},
	completiondate: {
		headerSize: 'h5',
		iconName: 'calendar alternate outline',
		labelText: 'Completion date',
		order: 6,
		color: 'orange',
	},
	birthdate: {
		headerSize: 'h5',
		iconName: 'calendar alternate outline',
		labelText: 'Birthdate',
		order: 6,
		color: 'grey',
	},
	deathdate: {
		headerSize: 'h5',
		iconName: 'calendar alternate outline',
		labelText: 'Deathdate',
		order: 6,
		color: 'grey',
	},
	placeofbirthen: {
		headerSize: 'h5',
		iconName: 'map marker alternate',
		labelText: 'Place of birth',
		order: 6,
		color: 'yellow',
	},
	placeofdeathen: {
		headerSize: 'h5',
		iconName: 'map marker alternate',
		labelText: 'Place of death',
		order: 6,
		color: 'yellow',
	},
	metadata: {
		headerSize: 'h5',
		iconName: 'map marker alternate',
		labelText: 'Metadata',
		order: 6,
		color: 'blue',
	},
};

const CreateLabelText = ({ selection }) => {
	const labelConfigKeys = Object.keys(labelTextConfig);
	if (!selection) return;
	const selectKeys = Object.keys(selection);
	// eslint-disable-next-line consistent-return
	return selectKeys
		.filter((k) => labelConfigKeys.includes(k))
		.map((v, i) => (
			<Header
				key={`${selection[v]}-${Math.round(Math.random() * 10000)}`}
				as={(labelTextConfig[v] && labelTextConfig[v].headerSize) || labelTextConfig.default.headerSize}
				style={{ order: labelTextConfig[v].order, marginTop: '10px', marginBottom: '10px' }}
			>
				<Label as="a" style={{ marginRight: '15px' }} color={labelTextConfig[v].color}>
					<Icon
						name={(labelTextConfig[v] && labelTextConfig[v].iconName) || ''}
						// content={(labelTextConfig[v] && labelTextConfig[v].labelText) || ''}
					/>
					{(labelTextConfig[v] && labelTextConfig[v].labelText) || ''}
				</Label>
				{/* 若是波斯語，則文字方向由又到左 */}
				<span dir={labelTextConfig[v].dir ? labelTextConfig[v].dir : 'default'}>{selection[v] || ''}</span>
			</Header>
		));
};

const PopUpModal = () => {
	const [state, dispatch] = useContext(StoreContext);
	const { map } = state;
	const { selection, popUp } = map;

	return (
		<Modal
			onClose={() =>
				dispatch({
					type: Act.POP_UP_MODAL,
					payload: false,
				})
			}
			onOpen={() =>
				dispatch({
					type: Act.POP_UP_MODAL,
					payload: true,
				})
			}
			open={popUp.displayModal}
			// trigger={<Button>Show Modal</Button>}
			size="small"
			className="map-pop-up-modal"
		>
			<Modal.Header>Publication Info</Modal.Header>
			<Modal.Content image>
				{/* <Image size="medium" src="/images/avatar/large/rachel.png" wrapped /> */}
				<Modal.Description>
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						{selection && <CreateLabelText selection={selection} />}
					</div>
				</Modal.Description>
			</Modal.Content>
			<Modal.Actions>
				<Button
					color="grey"
					onClick={() =>
						dispatch({
							type: Act.POP_UP_MODAL,
							payload: false,
						})
					}
				>
					Close
				</Button>
			</Modal.Actions>
		</Modal>
	);
};
export default PopUpModal;
